import { Injectable } from '@angular/core';
import {
  Section84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1.options';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class Section84_1FormFactory extends CalculationBaseFormFactory {

  constructor(protected readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = Section84_1Options;
  }

  //
  // addShareClass() {
  //     const arrayForm: ArrayForm<Section84_1ShareClassOptions> = this.form.formElements.shareClasses as ArrayForm<Section84_1ShareClassOptions>;
  //     arrayForm.add(this.formFactory.createForm(new Section84_1ShareClassOptions()));
  // }
  //
  // removeShareClass(index: number) {
  //     (this.form.formElements.shareClasses as ArrayForm<Section84_1ShareClassOptions>).delete(index);
  // }
  //
  // getShareClassesFormElements(): BaseForm<Section84_1ShareClassOptions>[] {
  //     return (this.form.formElements.shareClasses as ArrayForm<Section84_1ShareClassOptions>).getForms();
  // }
  //
  // getGetMetadataFormElements(): BaseForm<Section84_1MetadataOptions> {
  //     return (this.form.formElements.metadata as BaseForm<Section84_1MetadataOptions>);
  // }
}
